const routes = [
    {
        path: "/",
        render: () => import("../../Pages/Core/Security/Login/Login.svelte"),
        secure: false,
        title: "Home" // calls to login will send the person to home if logged in
    },
    {
        path: "/login",
        render: () => import("../../Pages/Core/Security/Login/Login.svelte"),
        secure: false,
        title: "Login"
    },
    {
        path: "/logout",
        render: () => import("../../Pages/Core/Security/Logout/Logout.svelte"),
        secure: false,
        title: "Logout"
    },
    {
        path: "/reset-password",
        render: () => import("../../Pages/Core/Security/PasswordResetSubmit/PasswordResetSubmit.svelte"),
        secure: false,
        title: "Password Reset"
    }
];

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes
};

export default routerConfig;